export const magdalenaKruczynska = {
    'meta': {
        'title': 'Psychoterapeuta Magdalena Kruczyńska • Centrum COLLIGO',
        'description': 'Psychoterapeuta psychodynamiczny, absolwentka Szkoły Medycznej w Toruniu oraz Wydziału Nauk Społecznych na Uniwersytecie Mikołaja Kopernika w Toruniu.'
    },
    'url': {
        'address': '/torun/zespol/psychoterapeuta-magdalena-kruczynska/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/magdalena-kruczynska.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psychoterapeuta Magdalena Kruczynska'
        }
    }
}